module.exports = "/images/easypedido-tienda640x640.jpg";